import type { TargetSessionPreview } from "api/types/aba";

export type { TargetSessionPreview };

function parseDate(value?: string | null): Date | null {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function getSessionDate(session: TargetSessionPreview): Date | null {
  const startedDate = parseDate(session.startedAt ?? session.started_at);
  if (startedDate) return startedDate;

  return parseDate(session.createdAt ?? session.created_at);
}

export function getSessionCount(sessions?: TargetSessionPreview[] | null): number {
  return sessions?.length ?? 0;
}

export function getLastSessionDate(sessions?: TargetSessionPreview[] | null): Date | null {
  if (!sessions?.length) return null;

  const latestMillis = sessions.reduce<number | null>((latest, session) => {
    const sessionDate = getSessionDate(session);
    if (!sessionDate) return latest;

    const sessionMillis = sessionDate.getTime();
    if (latest === null || sessionMillis > latest) return sessionMillis;
    return latest;
  }, null);

  return latestMillis === null ? null : new Date(latestMillis);
}

export function formatSessionDate(date: Date | null): string {
  if (!date || Number.isNaN(date.getTime())) return "--";

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  }).format(date);
}
